const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function isValidEmail(value: string): boolean {
    if (!value || value.trim().length === 0) return true; // Empty is valid (use required check separately)
    return EMAIL_REGEX.test(value.trim());
}

const TEL_PATTERN_REGEX = /^[\d\s\-()+]+$/;
const MIN_TEL_DIGITS = 10;
const MAX_TEL_LENGTH = 20;

export function isValidTelephone(value: string): boolean {
    if (!value || value.trim().length === 0) return true;

    const trimmed = value.trim();

    // Check pattern (only digits, spaces, dashes, parentheses, plus)
    if (!TEL_PATTERN_REGEX.test(trimmed)) {
        return false;
    }

    // Check digit count
    const digitCount = (trimmed.match(/\d/g) || []).length;
    if (digitCount < MIN_TEL_DIGITS) {
        return false;
    }

    // Check total length
    if (trimmed.length > MAX_TEL_LENGTH) {
        return false;
    }

    return true;
}

const URL_REGEX = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-./?%&=]*)?$/i;

export function isValidUrl(value: string): boolean {
    if (!value || value.trim().length === 0) return true;
    return URL_REGEX.test(value.trim());
}

export function isValidNumber(value: string, min?: number, max?: number): boolean {
    if (!value || value.trim().length === 0) return true;

    const num = parseFloat(value);
    if (isNaN(num)) return false;

    if (min !== undefined && num < min) return false;
    if (max !== undefined && num > max) return false;

    return true;
}

const DATE_PLACEHOLDER_CHARS = ['D', 'M', 'Y'];

export function isDateIncomplete(value: string): boolean {
    if (!value) return false;
    return DATE_PLACEHOLDER_CHARS.some(char => value.includes(char));
}

const MAX_FILE_SIZE_MB = 28;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export function isFileSizeValid(file: File): boolean {
    return file.size <= MAX_FILE_SIZE_BYTES;
}

const NAME_REGEX = /^[\p{L}'\- ]+$/u;

export function isValidName(value: string): boolean {
    if (!value || value.trim().length === 0) return true; // Empty is valid (use required check separately)
    return NAME_REGEX.test(value.trim());
}

const COMPANY_NAME_REGEX = /^[A-Za-zА-Яа-яЁё0-9\s\-.&()]+$/;

export function isValidCompanyName(value: string): boolean {
    if (!value || value.trim().length === 0) return true; // Empty is valid (use required check separately)
    return COMPANY_NAME_REGEX.test(value.trim());
}

export function isValidBirthday(value: string, format: string): boolean {
    let day: number;
    let month: number;
    let year: number;

    let regex: RegExp;

    if (format === 'dd/MM/yyyy') {
        regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/;

        if (!regex.test(value)) return false;

        const parts = value.split('/').map(Number);
        [day, month, year] = parts;
    } else {
        // default MM/dd/yyyy
        regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(\d{4})$/;

        if (!regex.test(value)) return false;

        const parts = value.split('/').map(Number);
        [month, day, year] = parts;
    }

    const date = new Date(year, month - 1, day);

    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date > today) return false;

    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 120);
    minDate.setHours(0, 0, 0, 0);

    if (date < minDate) return false;

    return true;
}
